<script setup>
    import { router, useForm } from '@inertiajs/vue3';
    import { ref, reactive, onMounted } from 'vue';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import PreviewLayout from '@/Layouts/PreviewLayout.vue';
    import ShowAndFilterActions from '@/Pages/Toolkit/ShowAndFilterActions.vue';
    import DashboardSidebar from '@/Jetstream/DashboardSidebar.vue';
    import ActionsSearch from '@/Pages/Toolkit/Partials/ActionsSearch.vue';
    import ToolkitAuditorTeamQuestions from '@/Pages/Toolkit/Partials/ToolkitAuditorTeamQuestions.vue';
    import JetButton from '@/Jetstream/Button.vue';
    import JetDialogModal from '@/Jetstream/DialogModal.vue';
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue';
    import JetInput from '@/Jetstream/Input.vue';
    import JetInputError from '@/Jetstream/InputError.vue';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const submitConfirm = ref(false);
    const submitAuditConfirm = ref(false);

    const props = defineProps({
        toolkit: Object,
        actions: Array,
        areas: Array,
        statuses: Array,
        themes: Array,
        sdgs: Array,
        awards: Array,
        loggedInUserId: Number,
        currentToolkitTeamUsers: Array,
        team: Object,
        auditor: Boolean,
        auditorSession: Object,
        auditorTeamQuestions: Array,
        pastToolkit: Boolean,
        adminToolkit: Boolean,
        adminInfo: Object,
        currentActiveToolkit: Boolean,

        filters: {
            type: Object,
            default: () => ({}),
        }
    });

    const emit = defineEmits(['statusChanged']);

    const statusChanged = (action, status) => {
        emit('statusChanged', action, status);
    };

    let adminAudit = false;

    if((props.auditor && props.auditorSession) && !props.auditorSession.auditor_session_id) {
        adminAudit = true;
    }

    let programme = null;
    let organisation = null;

    if(props.adminToolkit && props.adminInfo) {
        programme = props.adminInfo['programme'];
        organisation = props.adminInfo['organisation'];
    } else {
        programme = router.page.props.ziggy.programme;
        organisation = router.page.props.ziggy.organisation;
    }

    const urlNamePrefix = organisation ? "gi." : "";
    const enabling = ref(false);

    const organisation_name = (programme.organisation_custom_name && programme.organisation_custom_name.length == 0) ? programme.organisation_custom_name : 'Organisation' ;

    let team_custom_name = programme.team_custom_name;

    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }


    const form = useForm({
        teamname: router.page.props.team.name,
        errors: {
            teamname: ''
        }
    });

    let evidence = false;

    props.actions.forEach(action => {
        if (action.evidence.length > 0) {
            evidence = true;
        }
    });

    const hasStatus = (action) => !action.status || action.status == 'undefined' || typeof(action.status) == 'undefined';

    const submitToolkit = (team_toolkit_id, toolkit_id, team_id) => {

        //validate teamname
        if (form.teamname.length <= 2) {
            form.errors.teamname = 'Team name must be longer than 2 characters';
        } else {
            router.put(route(urlNamePrefix+'toolkit-team.submit'),
            {
                team_toolkit_id: team_toolkit_id,
                toolkit_id: toolkit_id,
                team_id: team_id,
                team_name: form.teamname,
                actions: props.actions
            }, {
                onSuccess: page => {
                    //redirect to submission page
                },
                onError: (errors) => {
                    //do something else
                },
            });
            submitConfirm.value = false;
        }
    }

    const submitModal = () => {
        submitConfirm.value = true;
    };

    const closeModal = () => {
        submitConfirm.value = false;
    };

    let urlSlugForAuditor = (organisation === undefined || organisation === null) ? '/'+programme.slug : '/' + programme.slug + '/' + organisation.slug;
    let urlID = props.toolkit.toolkit_id;
    let toolkitType = 'toolkit';

    if (props.pastToolkit) {
        toolkitType = 'past-toolkit';
        urlID = props.toolkit.team_toolkit_id;
    }

    if (props.adminToolkit) {
        urlSlugForAuditor = '/admin/toolkit';
        toolkitType = 'admin';
        urlID = props.toolkit.team_toolkit_id;
    }

    const downloadEvidenceURL = urlSlugForAuditor + '/' + toolkitType + '/' + urlID + '/evidence';

    const downloadEvidence = () => {

        return axios.get(downloadEvidenceURL,
        { responseType: 'arraybuffer'} )
        .then(response => {
            console.log("Success");
            let fileName = downloadFile(response, 'customFilename')

            return axios.post(urlSlugForAuditor + '/' + toolkitType + '/' + props.toolkit.toolkit_id + '/deleteEvidence', {
                filePath: fileName
            });
        })
        .catch(function (error) {
            console.log("Error");

            var decodedString = String.fromCharCode.apply(null, new Uint8Array(error.response.data));
            var obj = JSON.parse(decodedString);
            var message = obj['message'];
            displayErrorMessage(message);
        });
    }

    const downloadFile = (response, customFilename) => {
        if (!response.data) {
            console.error('Invalid response data');
            return;
        }

        const blob = new Blob([response.data], {type: response.data.type});
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        let fileName = 'Evidence.zip';
        const contentDisposition = response.headers ? response.headers['content-disposition'] : null;
        if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (fileNameMatch != null && fileNameMatch[1]) {
                fileName = fileNameMatch[1].replace(/['"]/g, '');
            }
        }

        link.setAttribute('download', fileName);
        document.body.appendChild(link); // This line is required for Firefox
        link.click();

        if (link.parentNode) {
            link.parentNode.removeChild(link); // Support for IE
        }

        setTimeout(function () {
            window.URL.revokeObjectURL(url)
        }, 100)

        return fileName;
    }

    const displayErrorMessage = (message) => {
        //do something here
    }

    // This is the function that submits the audit to the AuditController
    const submitAudit = ($event) => {
        router.post(route(urlNamePrefix + 'auditor.submit-audit', { 'subdomain': 'auditor'}),
        {
            // What goes in here?
        },
        {
            preserveState: true,
            preserveScroll: true,
            onSuccess: function() {
                console.log('Success!');
                submitAuditConfirm.value = false;

            },
            onError: (errors) => {
                console.log('Fail!');
                submitAuditConfirm.value = false;
            },

        });
    }

    const submitAuditModal = () => {
        submitAuditConfirm.value = true;
    };

    const closeAuditModal = () => {
        submitAuditConfirm.value = false;
    };

    const layoutFile = props.adminToolkit ? PreviewLayout : AppLayout;


</script>


<template>
    <component :is="layoutFile" title="Toolkit" :auditor="auditor">
        <div class="text-center py-2 lg:px-2 mb-5 w-full  bg-[#3d5567]" v-if="props.adminToolkit">
            <div class="flex items-center p-2 leading-none text-indigo-100 lg:rounded-full lg:inline-flex" role="alert">
                <span class="flex-auto mr-2 font-semibold text-left">{{$t('toolkit.past.adminToolkit')}}</span>
            </div>
        </div>

        <div class="text-center py-2 lg:px-2 mb-5 w-full  bg-[#3d5567]" v-if="props.pastToolkit && !props.currentActiveToolkit">
            <div class="flex items-center p-2 leading-none text-indigo-100 lg:rounded-full lg:inline-flex" role="alert">
                <span class="flex-auto mr-2 font-semibold text-left"  v-html="$t('toolkit.past.readOnly', {link: '/' + programme.slug + (organisation ? '/' + organisation.slug + '/' : '/') + 'toolkits'})"></span>
            </div>
        </div>

        <div class="container flex flex-col justify-between w-full mx-auto lg:flex-row">

            <div id="sos-programme-dashboard-sidebar" class="order-2 w-full min-h-screen p-10 pt-5 lg:order-1 lg:w-1/4 xl:w-1/5">
                <DashboardSidebar v-if="!adminToolkit" />
            </div>

            <div class="order-1 w-full lg:order-2 lg:w-3/4 xl:w-4/5 sos-programme-dashboard-content">

                <div class="pt-3 pl-10 pr-10 mb-10 overflow-hidden lg:pr-0">
                    <div id="toolkit-header" class="md:flex">
                        <div class="md:basis-1/2">
                            <h1 class="pt-5 dashboard-title"><span v-if="organisation">{{ organisation.name }}</span> <span v-if="!organisation">{{ programme.name }}</span> {{ $page.props.toolkit.name }} {{$t('toolkit.toolkit')}}</h1>
                            <p class="font-bold" ><span style="text-transform: capitalize;">{{$t(team_name)}}</span>: {{ $page.props.team.name }}</p>
                        </div>
                        <div class="text-right md:basis-1/2">
                            <JetButton v-if="!auditor && !pastToolkit && !adminToolkit" type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling" v-on:click="submitModal()">
                                {{$t('toolkit.submit')}}
                            </JetButton>

                            <JetButton v-if="auditor || pastToolkit || adminToolkit" type="button" class="bg-[#83c341] text-white mr-2" :class="{ 'opacity-25': enabling }" :disabled="enabling || !evidence" v-on:click="downloadEvidence()">
                                {{$t('auditor.evidence')}}
                            </JetButton>

                            <JetButton v-if="auditor" type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling || adminAudit" v-on:click="submitAuditModal()">
                                {{$t('auditor.submit')}}
                            </JetButton>

                            <ActionsSearch />
                        </div>
                    </div>

                    <div class="toolkit-intro">
                        <p>{{ $t('toolkit.intro_text', { team_name: team_name }) }}</p>
                    </div>

                    <div class="pt-5 lg:pr-0">

                        <ToolkitAuditorTeamQuestions v-if="auditor" :toolkit="toolkit" :auditor="auditor" ref="UpdateAuditorTeamQuestions" :auditorTeamQuestions="auditorTeamQuestions" :adminAudit="adminAudit" />

                        <div class="text-center py-2 lg:px-2 mb-5 w-full rounded-lg bg-[#3d5567]" v-if="props.toolkit.locked">
                            <div class="flex items-center p-2 leading-none text-indigo-100 lg:rounded-full lg:inline-flex" role="alert">
                                <span class="flex-auto mr-2 font-semibold text-left">{{$t('toolkit.past.toolkit_locked_warning')}}</span>
                            </div>
                        </div>

                        <ShowAndFilterActions :toolkit="toolkit" :currentToolkitTeamUsers="currentToolkitTeamUsers" :actions="actions" :areas="areas" :statuses="statuses" :themes="themes" :sdgs="sdgs" :awards="awards" :loggedInUserId="loggedInUserId" :team="team" :auditor="auditor" :auditorSession="auditorSession" :adminAudit="adminAudit" :pastToolkit="pastToolkit" :adminToolkit="adminToolkit" :adminInfo="adminInfo" :currentActiveToolkit="currentActiveToolkit" :filters="filters" @statusChanged="statusChanged" />
                    </div>
                </div>
            </div>
        </div>
    </component>

    <JetDialogModal :show="submitConfirm" @close="closeModal">
            <template #title>
                <span class="text-lg font-bold">{{ $t('toolkit.submission.title') }}</span>
            </template>

            <template #content>
                <p class="font-bold">{{$t('toolkit.submission.prompt')}}</p>
                <p>{{$t('toolkit.submission.warning', { team_name: team_name })}}</p>
                <div v-if="!auditor && !pastToolkit">
                    <p class="font-bold" style="margin-top:10px;">{{$t('toolkit.submission.name_change', { team_name: team_name })}}</p>
                    <JetInput
                        id="teamname"
                        v-model="form.teamname"
                        type="text"
                        class="block w-full mt-1"
                        autofocus
                    />
                    <JetInputError :message="form.errors.teamname" class="mt-2" />
                </div>
            </template>

            <template #footer>
                <JetSecondaryButton @click="closeModal">
                    {{$t('toolkit.submission.cancel')}}
                </JetSecondaryButton>

                <JetButton
                    class="ml-3"
                    @click="submitToolkit(toolkit.team_toolkit_id, toolkit.toolkit_id, $page.props.auth.user.current_team.id)">
                    {{$t('toolkit.submission.submit')}}
                </JetButton>
            </template>
        </JetDialogModal>

        <JetDialogModal v-if="auditor" :show="submitAuditConfirm" @close="closeAuditModal">
            <template #title>
                <span class="text-lg font-bold">{{ $t('auditor.submit_audit.heading') }}</span>
            </template>

            <template #content>
                <h3 class="mb-5 font-bold">{{$t('auditor.submit_audit.prompt')}}</h3>
                <p class="mb-3">{{$t('auditor.submit_audit.warning')}}</p>
                <p v-if="auditorTeamQuestions" class="mb-3">{{$t('auditor.submit_audit.reminder')}}</p>
            </template>

            <template #footer>
                <JetSecondaryButton @click="closeAuditModal">
                    {{$t('auditor.submit_audit.cancel')}}
                </JetSecondaryButton>

                <JetButton
                    class="ml-3"
                    @click="submitAudit()">
                    {{$t('auditor.submit_audit.submit')}}
                </JetButton>
            </template>
        </JetDialogModal>
</template>
